import { Button, ModalWindow, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './DailyrentReviewDesktopModal.css';
import qrcodeImg from './assets/qrcode-img.jpg';

interface IDailyrentReviewDesktopModal {
  isOpen: boolean;
  closeModal(): void;
  onDismissClick(): void;
}

export const DailyrentReviewDesktopModal = ({ isOpen, closeModal, onDismissClick }: IDailyrentReviewDesktopModal) => {
  return (
    <ModalWindow open={isOpen} onClose={closeModal} size="M" fixed={false}>
      <div className={styles['content']} data-name="DailyrentReviewDesktopModal">
        <div className={styles['img-container']}>
          <img
            className={styles['img']}
            src={qrcodeImg}
            width={153}
            height={141}
            alt="QR-код для скачивания приложения"
          />
        </div>
        <div className={styles['text']}>
          <UIHeading2 textAlign="center" display="block">
            Скачайте приложение — отсканируйте QR-код
          </UIHeading2>
          <span className={styles['subtitle']}>
            <UIText1 textAlign="center" display="block">
              Пока оставлять и читать отзывы можно только там
            </UIText1>
          </span>
        </div>
        <div className={styles['dismiss-button']}>
          <Button onClick={onDismissClick} size="XS">
            Не сейчас
          </Button>
        </div>
      </div>
    </ModalWindow>
  );
};
